import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { ITariffOptionCardBlock } from './tariff-option-card.model';
import { ButtonComponent } from '../../../reusable/button';
import { ListComponent } from '../../../reusable/list';

@Component({
    selector: 'app-tariff-option-card',
    imports: [ButtonComponent, ListComponent],
    templateUrl: './tariff-option-card.component.html',
    styleUrl: './tariff-option-card.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'app-tariff-option-card',
    },
})
export class TariffOptionCardComponent {
    block = input.required<ITariffOptionCardBlock>();
}
